import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import { ModelWrapperWithButton } from "../company/component/ModelWrapperWithButton";
import RegionSelector from "app/pages/component/RegionSelector";
import { getRegion } from "sr/utils/api/user/getRegion";
import { deleteRegion } from "sr/utils/api/user/deleteRegion";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";
import SmartSearchSelect from "sr/helpers/ui-components/SmartSearchSelect";
import { getUserFullProfile } from "sr/utils/api/user/user";
import { updateCompany } from "sr/utils/api/company/updateCompany";
import { fetchCompany } from "sr/redux/reducers/company";
import { useDispatch } from "react-redux";
import { AppDispatch } from "sr/redux/store";
import { updateIndividual } from "sr/utils/api/individual/updateIndividual";
import { fetchIndividual } from "sr/redux/reducers/individual";

interface Region {
  _id: string;
  regionId: {
    city: string;
    state: string;
  };
}

const RegionInfoSettings: React.FC = () => {
  const [regions, setRegions] = useState<Region[]>([]);
  const [reload, setReload] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);
  const [userData, setUserData] = useState(null);
  const [primaryRegionId, setPrimaryRegionId] = useState("");
  const [showAllRegions, setShowAllRegions] = useState(false);
  const dispatch = useDispatch<AppDispatch>();

  const fetchRegions = async () => {
    const res = await getRegion();
    if (res) {
      setRegions(res.data);
    }
  };

  const fetchUser = async () => {
    const res = await getUserFullProfile();
    if (res) {
      setUserData(res?.data);
      setPrimaryRegionId(res?.data?.regionId);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  useEffect(() => {
    fetchRegions();
  }, [reload]);

  console.log("userData", userData);

  const handleDeleteRegion = async (id: string) => {
    const res = await deleteRegion(id);
    if (res) {
      toast.success("Region deleted successfully");
    }
    setReload(!reload);
  };

  const handleRegionChange = (selectedItem: any) => {
    if (!selectedItem) return;

    setPrimaryRegionId(selectedItem);

    if (userData?.type === "company") {
      updateCompany({
        id: userData?.user_type_detail?.id,
        address: {
          regionId: selectedItem,
        }
      }).then((result) => {
        if (result?.success) {
          dispatch(fetchCompany({ id: userData?.user_type_detail?.id }));
        }
      });
    } else if (userData?.type === "individual") {
      updateIndividual({
        id: userData?.user_type_detail?.id,
        regionId: selectedItem
      }).then((result) => {
        if (result?.success) {
          dispatch(fetchIndividual({ id: userData?.user_type_details?.id }));
        }
      });
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-4 m-4">
      <div className="flex justify-end">
        <button
          onClick={() => setShowAddForm((prev) => !prev)}
          className="rounded-full
                                bg-[#ff39b3] font-bold
                                p-2
                                text-white
                                w-44
                                cursor-pointer
                                hover:bg-navy"
        >
          <FontAwesomeIcon icon={faPlus} />
          <FormattedMessage id="USER.REGION.ADD" defaultMessage="Add Region" />
        </button>
      </div>
      <div className="mb-6">
        <div className="w-full text-[14px] font-[600]">
          <FormattedMessage
            id="CLEANER.PROFILE.REGIONS.PRIMARY.TITLE"
            defaultMessage="Primary Region"
          />
        </div>
        <div style={{ marginTop: -25 }}>
          <SmartSearchSelect
            value={primaryRegionId}
            label=""
            options={primaryRegionId ? [primaryRegionId] : []}
            onChange={handleRegionChange}
            placeholder="Search for a Region..."
          />
        </div>
      </div>
      <div className="w-full text-[14px] font-[600] mb-4">
        <FormattedMessage
          id="CLEANER.PROFILE.REGIONS.NEARBY.TITLE"
          defaultMessage="Additional/Nearby Regions"
        />
      </div>

      {regions.length > 0 ? (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 m-4">
            {regions
              .slice(0, showAllRegions ? regions.length : 6)
              .map((item) => (
                <div
                  key={item._id}
                  className="border rounded-lg p-3 bg-gray-50 hover:bg-gray-100 transition flex items-center justify-between"
                >
                  <h5>
                    {item.regionId.city}
                    {item.regionId.state ? ` (${item.regionId.state})` : ""}
                  </h5>

                  <FontAwesomeIcon
                    icon={faTrash}
                    className="text-gray-400 hover:text-red-500 cursor-pointer pl-2"
                    onClick={() => handleDeleteRegion(item._id)}
                  />
                </div>
              ))}
          </div>
          {regions.length > 6 && (
            <div className="m-4 mt-0">
              <button
                type="button"
                className="text-[#0078ae] font-bold cursor-pointer"
                onClick={() => setShowAllRegions(!showAllRegions)}
              >
                {showAllRegions ? "View Less" : "View All"}
              </button>
            </div>
          )}
        </>
      ) : (
        <div className="text-center text-gray-500 py-6">
          <FormattedMessage
            id="USER.REGION.NOT.FOUND"
            defaultMessage="No regions found"
          />
        </div>
      )}
      <ModelWrapperWithButton
        showModal={showAddForm}
        nofooter={true}
        headertitle="Add Region"
        onCheckModel={() => {
          setShowAddForm(false);
          setReload(!reload);
        }}
      >
        <RegionSelector />
      </ModelWrapperWithButton>
    </div>
  );
};

export default RegionInfoSettings;
